import React from "react";

export const AnnouncementBg: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 48"
      fill="none"
      className={className}
      preserveAspectRatio="none"
    >
      <g clipPath="url(#clip0_7455_20653)" filter="url(#filter0_n_7455_20653)">
        <rect width="1440" height="48" fill="url(#paint0_linear_7455_20653)" />
      </g>
      <defs>
        <filter
          id="filter0_n_7455_20653"
          x="0"
          y="0"
          width="1440"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feTurbulence
            type="fractalNoise"
            baseFrequency="1.4285714626312256 1.4285714626312256"
            stitchTiles="stitch"
            numOctaves="3"
            result="noise"
            seed="7613"
          />
          <feColorMatrix
            in="noise"
            type="luminanceToAlpha"
            result="alphaNoise"
          />
          <feComponentTransfer in="alphaNoise" result="coloredNoise1">
            <feFuncA
              type="discrete"
              tableValues="1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 1 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 "
            />
          </feComponentTransfer>
          <feComposite
            operator="in"
            in2="shape"
            in="coloredNoise1"
            result="noise1Clipped"
          />
          <feFlood
            floodColor="rgba(255, 255, 255, 0.13)"
            result="color1Flood"
          />
          <feComposite
            operator="in"
            in2="noise1Clipped"
            in="color1Flood"
            result="color1"
          />
          <feMerge result="effect1_noise_7455_20653">
            <feMergeNode in="shape" />
            <feMergeNode in="color1" />
          </feMerge>
        </filter>
        <linearGradient
          id="paint0_linear_7455_20653"
          x1="0"
          y1="24"
          x2="1440"
          y2="24"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FB2338" />
          <stop offset="0.495192" stopColor="#BE49E7" />
          <stop offset="1" stopColor="#0C4FDC" />
        </linearGradient>
        <clipPath id="clip0_7455_20653">
          <rect width="1440" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
